import React from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      scope.setLevel(this.props.severity);

      Sentry.captureException(error);
    });

    this.setState({ hasError: true });

    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  fallback: PropTypes.element,
  severity: PropTypes.oneOf([
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical',
  ]),
};
